export default __webpack_public_path__ + "static/media/panel-library.4fed99e0.svg";